import { useLayoutEffect } from 'react';

import { useCommentsPanelState } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';

import { updateVisibleReplies, type UpdateVisibleRepliesProps } from '../helpers/repliesHelpers.ts';

export const useUpdateVisibleReplies = ({
	allReplies,
	isParentCommentOpen,
	currentReplyView,
	latestReplies,
	parentCommentId,
	setVisibleReplies,
	allowNestedReplies = false,
}: UpdateVisibleRepliesProps) => {
	const { currentView } = useCommentsPanelState();

	useLayoutEffect(() => {
		updateVisibleReplies({
			parentCommentId,
			currentReplyView,
			setVisibleReplies,
			allReplies,
			isParentCommentOpen,
			latestReplies,
			currentView,
			allowNestedReplies,
		});
	}, [
		allReplies,
		currentReplyView,
		isParentCommentOpen,
		latestReplies,
		parentCommentId,
		setVisibleReplies,
		currentView,
		allowNestedReplies,
	]);
};
